import { createSlice } from "@reduxjs/toolkit";
import { getCurrentContractAddresses } from "src/configs/address";
import { getCurrentNetwork } from "src/configs/connection-config";
import { FS } from "src/configs/constance";
import { ERR_TOP_CENTER } from "src/hooks/useNotify";
import { getSelectedMarket, setSelectedMarket } from "src/utils";

const RESPONSE_TIME_LOWER_BOUND = 1250;

export const fetchConfig = (enqueueSnackbar) => async (dispatch) => {
  try {
    dispatch(startFetchConfig());
    const network = getCurrentNetwork();
    const addresses = getCurrentContractAddresses();
    const assets = [];

    const start = Date.now();
    const end = Date.now();
    const delta = end - start;

    if (delta < RESPONSE_TIME_LOWER_BOUND) {
      setTimeout(() => {
        dispatch(fetchConfigSuccess({ network, addresses, assets }));
      }, RESPONSE_TIME_LOWER_BOUND - delta);
    } else dispatch(fetchConfigSuccess({ network, addresses, assets }));
  } catch (error) {
    console.error(error);
    dispatch(fetchConfigFail());
    enqueueSnackbar(JSON.stringify(error.message), ERR_TOP_CENTER);
  }
};

const configSlice = createSlice({
  name: "configSlice",
  initialState: {
    fetchingStatus: FS.INITIAL,
    network: null,
    addresses: null,
    assets: null,
    market: getSelectedMarket(),
  },
  reducers: {
    startFetchConfig: (state, _) => {
      state.fetchingStatus = FS.FETCHING;
    },
    fetchConfigSuccess: (state, action) => {
      Object.assign(state, action.payload);
      state.fetchingStatus = FS.SUCCESS;
    },
    fetchConfigFail: (state, _) => {
      state.fetchingStatus = FS.FAIL;
    },
    setMarket: (state, action) => {
      state.market = action.payload;
      setSelectedMarket(action.payload);
    },
  },
});

export default configSlice.reducer;
export const { fetchConfigSuccess, startFetchConfig, fetchConfigFail, setMarket } = configSlice.actions;
